import { IState } from '../../../store';
import { selectOfferAgent } from '../selectOfferAgent';

export const selectAgencyAvatarUrl = (state: IState): string | null => {
  const agent = selectOfferAgent(state);

  return agent?.masterAgent?.absoluteAvatarUrl || null;
};
